// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect, useRef } from 'react';
import { AUTO_SAVE_DEBOUNCE_MS } from '../constants';

export function useAutoSave(value: string, lastSavedValue: string, onSave: (value: string) => void) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onSaveRef = useRef(onSave);
  const lastSavedRef = useRef(lastSavedValue);

  onSaveRef.current = onSave;
  lastSavedRef.current = lastSavedValue;

  useEffect(() => {
    const trimmed = value.trim();
    if (trimmed === lastSavedRef.current.trim()) return;
    if (!trimmed) return;

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onSaveRef.current(trimmed);
    }, AUTO_SAVE_DEBOUNCE_MS);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [value]);
}
